import { Particle } from './types';
import { PARTICLE_POOL_SIZE, COL_WOOD_PARTICLE, COL_COIN_PARTICLE, COL_SPARKLE, COL_BOOP_SPARKLE } from './constants';

const pool: Particle[] = [];

export function initParticles(): void {
  for (let i = 0; i < PARTICLE_POOL_SIZE; i++) {
    pool.push({
      x: 0, y: 0, vx: 0, vy: 0,
      life: 0, maxLife: 0,
      color: '#fff', size: 3, gravity: 0,
    });
  }
}

function spawn(x: number, y: number, vx: number, vy: number, color: string, life: number, size: number, gravity: number): Particle | null {
  for (const p of pool) {
    if (p.life <= 0) {
      p.x = x; p.y = y;
      p.vx = vx; p.vy = vy;
      p.color = color;
      p.life = life; p.maxLife = life;
      p.size = size;
      p.gravity = gravity;
      return p;
    }
  }
  return null;
}

export function spawnChopParticles(x: number, y: number): void {
  for (let i = 0; i < 8; i++) {
    const angle = Math.random() * Math.PI * 2;
    const speed = 40 + Math.random() * 80;
    spawn(x, y, Math.cos(angle) * speed, Math.sin(angle) * speed - 40,
      COL_WOOD_PARTICLE, 0.5 + Math.random() * 0.3, 3 + Math.random() * 3, 200);
  }
}

export function spawnCoinParticles(x: number, y: number): void {
  for (let i = 0; i < 6; i++) {
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.8;
    const speed = 60 + Math.random() * 60;
    spawn(x, y, Math.cos(angle) * speed, Math.sin(angle) * speed,
      COL_COIN_PARTICLE, 0.6 + Math.random() * 0.3, 4 + Math.random() * 3, 180);
  }
}

export function spawnBoopParticles(x: number, y: number): void {
  for (let i = 0; i < 12; i++) {
    const angle = Math.random() * Math.PI * 2;
    const speed = 30 + Math.random() * 100;
    const color = Math.random() > 0.5 ? COL_BOOP_SPARKLE : COL_SPARKLE;
    spawn(x, y, Math.cos(angle) * speed, Math.sin(angle) * speed - 30,
      color, 0.4 + Math.random() * 0.4, 3 + Math.random() * 5, 100);
  }
}

export function spawnBuildParticles(x: number, y: number): void {
  for (let i = 0; i < 10; i++) {
    const angle = Math.random() * Math.PI * 2;
    const speed = 20 + Math.random() * 60;
    spawn(x, y, Math.cos(angle) * speed, Math.sin(angle) * speed - 20,
      COL_SPARKLE, 0.5 + Math.random() * 0.3, 3 + Math.random() * 3, 150);
  }
}

export function updateParticles(dt: number): Particle[] {
  const alive: Particle[] = [];
  for (const p of pool) {
    if (p.life <= 0) continue;
    p.life -= dt;
    p.x += p.vx * dt;
    p.y += p.vy * dt;
    p.vy += p.gravity * dt;
    if (p.life > 0) alive.push(p);
  }
  return alive;
}

export function getAliveParticles(): Particle[] {
  return pool.filter(p => p.life > 0);
}
